interface IBreakpoints {
    [key: string]: number;
}

interface IMediaQueryStrings {
    [key: string]: string;
}

export type IMatchingQueries = { [key in Breakpoints]?: boolean };

export type Breakpoints =
    | "ratMin"
    | "ratMax"
    | "rabbitMin"
    | "rabbitMax"
    | "catMin"
    | "catMax"
    | "dogMin"
    | "dogMax"
    | "wolfMin"
    | "wolfMax"
    | "lionMin"
    | "horseMin"
    | "horseMax"
    | "rhinoMin"
    | "rhinoMax"
    | "elephantMin"
    | "elephantMax";

export const breakpoints: IBreakpoints = {
    rat: 360,
    rabbit: 480,
    cat: 640,
    dog: 768,
    wolf: 1024,
    lion: 1100,
    horse: 1400,
    rhino: 1520,
    elephant: 1670
};

const mediaQueries: IMediaQueryStrings = Object.keys(breakpoints).reduce(
    (queryStrings: IMediaQueryStrings, key) => {
        queryStrings[`${key}Min`] = `(min-width: ${breakpoints[key]}px)`;
        queryStrings[`${key}Max`] = `(max-width: ${breakpoints[key] - 1}px)`;
        return queryStrings;
    },
    {}
);

const setupMediaQueryListeners = () => {
    Object.keys(mediaQueries).forEach((key: string) => {
        const mediaQuery = matchMedia(mediaQueries[key]);

        handleMediaMatch(mediaQuery.matches, key as Breakpoints); // Initial values
        mediaQuery.addListener(event => handleMediaMatch(event.matches, key as Breakpoints));
    });
};

const currentMediaQueries: IMatchingQueries = {};
const handleMediaMatch = (isMatching: boolean, key: Breakpoints) => (currentMediaQueries[key] = isMatching);

if (!__SERVER__) {
    setupMediaQueryListeners();
}

export { currentMediaQueries };
